const Margins = theme => {
  return {
    marginTop:theme.spacing.unit * 10,
  }
}

export default Margins



// WEBPACK FOOTER //
// ./src/styles/mixins/margins.js